import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faHashtag, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        NOMBRE: '',
        NIT_CONTRIBUYENTE: '',
        ID_DEPARTAMENTO: '',
        ID_MUNICIPIO: '',
        DIRECCION_CONTRIBUYENTE: '',
        CORREO_ELECTRONICO: '',
        SECTOR_CONTRIBUYENTE: '',
        RESPONSABLE_PAGO: '',
        TELEFONO_RESP_PAGO: '',
        ID_TIPO_FACTURACION: '',
        TARIFA: '',
        ACUERDO_MCPAL: '',
        departamentos: [],
        municipios: [],
        errores: [],
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { NOMBRE, NIT_CONTRIBUYENTE, ID_DEPARTAMENTO, ID_MUNICIPIO, DIRECCION_CONTRIBUYENTE, CORREO_ELECTRONICO, SECTOR_CONTRIBUYENTE, RESPONSABLE_PAGO, TELEFONO_RESP_PAGO, ID_TIPO_FACTURACION, TARIFA, ACUERDO_MCPAL } = this.state;
        var errores = [];
        if (!NOMBRE) { errores.push("error_nombre"); }
        if (!NIT_CONTRIBUYENTE) { errores.push("error_nit"); }
        if (!ID_DEPARTAMENTO) { errores.push("error_id_departamento"); }
        if (!ID_MUNICIPIO) { errores.push("error_id_municipio"); }
        if (!DIRECCION_CONTRIBUYENTE) { errores.push("error_direccion"); }
        if (!CORREO_ELECTRONICO) { errores.push("error_correo"); }
        if (!SECTOR_CONTRIBUYENTE) { errores.push("error_sector"); }
        if (!RESPONSABLE_PAGO) { errores.push("error_respons"); }
        if (!TELEFONO_RESP_PAGO) { errores.push("error_telefono"); }
        if (!ID_TIPO_FACTURACION) { errores.push("error_tipfact"); }
        if (!TARIFA) { errores.push("error_tarifa"); }
        if (!ACUERDO_MCPAL) { errores.push("error_acuerdo"); }
        console.log(errores.length);
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            NOMBRE: NOMBRE,
            NIT_CONTRIBUYENTE: NIT_CONTRIBUYENTE,
            ID_DEPARTAMENTO: document.getElementById("ID_DEPARTAMENTO").value,
            ID_MUNICIPIO: document.getElementById("ID_MUNICIPIO").value,
            DIRECCION_CONTRIBUYENTE: DIRECCION_CONTRIBUYENTE,
            CORREO_ELECTRONICO: CORREO_ELECTRONICO,
            SECTOR_CONTRIBUYENTE: SECTOR_CONTRIBUYENTE,
            RESPONSABLE_PAGO: RESPONSABLE_PAGO,
            TELEFONO_RESP_PAGO: TELEFONO_RESP_PAGO,
            ID_TIPO_FACTURACION: ID_TIPO_FACTURACION,
            TARIFA: TARIFA,
            ACUERDO_MCPAL: ACUERDO_MCPAL
        }
        Swal.showLoading();
        authAxios.post("contribuyentes/registrar", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Contribuyente!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterContribuyentes");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Contribuyente!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    cargadpto() {
        Swal.showLoading();
        authAxios.get("departamentos/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, departamentos: datosRespuesta.data.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    municipios(dep) {
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + dep)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, municipios: datosRespuesta.data, load: '' });
                window.$("#ID_MUNICIPIO").focus();
                Swal.close();
            })
            .catch(console.log);
    }
    buscarmunicipios() {
        var dep = document.getElementById("ID_DEPARTAMENTO").value;
        this.municipios(dep);
    }
    componentDidMount() {
        this.cargadpto()
    }
    render() {
        const { departamentos, municipios, NOMBRE, NIT_CONTRIBUYENTE, DIRECCION_CONTRIBUYENTE, CORREO_ELECTRONICO, SECTOR_CONTRIBUYENTE, RESPONSABLE_PAGO, TELEFONO_RESP_PAGO, ID_TIPO_FACTURACION, TARIFA, ACUERDO_MCPAL } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE CONTRIBUYENTES</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="NIT_CONTRIBUYENTE">NIT Contribuyente</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nit")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="NIT_CONTRIBUYENTE" id="NIT_CONTRIBUYENTE" value={NIT_CONTRIBUYENTE} placeholder="NIT Contribuyente" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el NIT</small>
                                                </div>
                                                <div className="col-md-10">
                                                    <label htmlFor="NOMBRE">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="NOMBRE" id="NOMBRE" value={NOMBRE} placeholder="Nombre" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Contribuyente</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="ID_DEPARTAMENTO">Departamento</label>
                                                    <select name="ID_DEPARTAMENTO"
                                                        id="ID_DEPARTAMENTO"
                                                        className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={e => {
                                                            this.buscarmunicipios(e);
                                                            this.cambioValor(e)
                                                        }}>
                                                        <option value="">Seleccione el Departamento</option>
                                                        {
                                                            departamentos.map((itemDepartamentos) => (
                                                                <option key={itemDepartamentos.ID_DEPARTAMENTO} value={itemDepartamentos.ID_DEPARTAMENTO}>{itemDepartamentos.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="ID_MUNICIPIO">Municipio</label>
                                                    <select name="ID_MUNICIPIO" id="ID_MUNICIPIO"
                                                        className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Municipio</option>
                                                        {
                                                            municipios.map((item) => (
                                                                <option key={item.ID_MUNICIPIO} value={item.ID_MUNICIPIO}>{item.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="DIRECCION_CONTRIBUYENTE">Dirección</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_direccion")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="DIRECCION_CONTRIBUYENTE" id="DIRECCION_CONTRIBUYENTE" value={DIRECCION_CONTRIBUYENTE} placeholder="Dirección" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite la Dirección</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="CORREO_ELECTRONICO">Correo Electrónico</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_correo")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="CORREO_ELECTRONICO" id="CORREO_ELECTRONICO" value={CORREO_ELECTRONICO} placeholder="Correo Electrónico" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Correo Electrónico</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <label htmlFor="SECTOR_CONTRIBUYENTE">Sector</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_sector")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="SECTOR_CONTRIBUYENTE" id="SECTOR_CONTRIBUYENTE" value={SECTOR_CONTRIBUYENTE} placeholder="Sector" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Sector</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-9">
                                                    <label htmlFor="RESPONSABLE_PAGO">Responsable Pago</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_respons")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="RESPONSABLE_PAGO" id="RESPONSABLE_PAGO" value={RESPONSABLE_PAGO} placeholder="Responsable Pago" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Responsable Pago</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="TELEFONO_RESP_PAGO">Tel. Reponsable Pago</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_telefono")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="TELEFONO_RESP_PAGO" id="TELEFONO_RESP_PAGO" value={TELEFONO_RESP_PAGO} placeholder="Tel. Responsable Pago" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Tel. Responsable Pago</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN TIPO FACTURACIÓN</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="ID_TIPO_FACTURACION">Tipo Facturación</label>
                                                    <select name="ID_TIPO_FACTURACION"
                                                        id="ID_TIPO_FACTURACION"
                                                        className={((this.verificarError("error_tipfact")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione Tipo Facturación</option>
                                                        <option value="1">CONSUMOS</option>
                                                        <option value="2">SALARIO</option>
                                                        <option value="3">UVT</option>
                                                        <option value="4">COMERCIAL</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo Facturación</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="TARIFA">Tarifa</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_tarifa")) ? "is-invalid" : "") + " form-control form-control-sm"} type="number" name="TARIFA" id="TARIFA" value={TARIFA} placeholder="Tarifa" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite la Tarifa</small>
                                                </div>
                                                <div className="col-md-7">
                                                    <label htmlFor="ACUERDO_MCPAL">Acuerdo Municipal</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_acuerdo")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="ACUERDO_MCPAL" id="ACUERDO_MCPAL" value={ACUERDO_MCPAL} placeholder="Acuerdo Municipal" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Acuerdo Municipal</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Contribuyente</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterContribuyentes"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;